// Redimensiona pra um quadrado pequeno antes de virar base64 — pra
// avatar/thumbnail (usuário, produto), que não precisa da resolução
// original da câmera. Extraída do MeuPerfilModal.jsx (30/07/2026) pra
// reaproveitar no cadastro de produto (foto no ranking da Sala 37) —
// mesmo propósito visual, mesma função, sem duplicar.
export const fotoQuadradaBase64 = (file, tam = 200) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (ev) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = tam; canvas.height = tam;
      const ctx = canvas.getContext('2d');
      const lado = Math.min(img.width, img.height);
      const sx = (img.width - lado) / 2, sy = (img.height - lado) / 2;
      ctx.drawImage(img, sx, sy, lado, lado, 0, 0, tam, tam);
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = reject;
    img.src = ev.target.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

// Comprime uma imagem antes de virar base64 — sem isso, uma foto de
// celular em resolução original (8-15MB) facilmente estoura o limite
// de payload do servidor (10mb), e o erro que volta nem é legível
// (não é um JSON com campo "erro", é o próprio Express rejeitando o
// corpo da requisição). Mesma lógica já usada em MidiaCaptura.jsx,
// extraída aqui pra reaproveitar nos formulários que lidam com
// anexos na mão (PA, Estudo de Viabilidade, Requisição de Compras).
//
// Vídeos e outros tipos de arquivo passam direto — canvas só
// resolve pra imagem.
export const comprimirImagemSeNecessario = (file, maxPx = 1600, qualidade = 0.85) => new Promise((resolve, reject) => {
  if (!file.type.startsWith('image/')) {
    // Não é imagem — não tem o que comprimir, só lê como está.
    const reader = new FileReader();
    reader.onload = (ev) => resolve(ev.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
    return;
  }
  const reader = new FileReader();
  reader.onload = (ev) => {
    const img = new Image();
    img.onload = () => {
      let w = img.width, h = img.height;
      if (w > maxPx || h > maxPx) {
        if (w > h) { h = Math.round(h * maxPx / w); w = maxPx; }
        else       { w = Math.round(w * maxPx / h); h = maxPx; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/jpeg', qualidade));
    };
    img.onerror = reject;
    img.src = ev.target.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});
